import React, { useEffect, useState } from "react";

const SEEN_KEY = "offernest_splash_seen_v1";

/**
 * Full-logo splash. Shows for ~600ms on the very first app load per browser
 * session, then never again until the key is cleared. Renders nothing on
 * subsequent navigations.
 */
export function SplashScreen() {
    const [visible, setVisible] = useState(() => {
        try { return sessionStorage.getItem(SEEN_KEY) !== "1"; } catch { return false; }
    });

    useEffect(() => {
        if (!visible) return undefined;
        try { sessionStorage.setItem(SEEN_KEY, "1"); } catch { /* private mode */ }
        const t = setTimeout(() => setVisible(false), 650);
        return () => clearTimeout(t);
    }, [visible]);

    if (!visible) return null;
    return (
        <div
            data-testid="splash-screen"
            className="fixed inset-0 z-[999] flex items-center justify-center bg-[#0B0B0B] animate-in fade-in-0"
        >
            <img
                src="/logo.png"
                alt="OfferNest"
                className="w-[70vw] max-w-[520px] animate-in zoom-in-95 fade-in-0"
                style={{ animationDuration: "500ms" }}
            />
        </div>
    );
}

export default SplashScreen;
